import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-blog-navigation.scss'
import '../../styles/components/search-input.scss'

export default register(`section-blog-navigation`, {
    onLoad() {
        document.addEventListener(`DOMContentLoaded`, () => {
            const searchInput = document.querySelector(`#blog-search-input`)
            const articles = document.querySelectorAll(`.article-card`)
            const articleResults = document.querySelector(`.article-results`)
            const noResults = document.querySelector(`.no-results`)

            searchInput.addEventListener(`input`, () => {
                const query = searchInput.value.trim().toLowerCase()
                let hasResults = false

                articles.forEach(article => {
                    const heading = article.querySelector(`.article-label`)?.textContent.toLowerCase() || ``
                    const title = article.querySelector(`.article-title`)?.textContent.toLowerCase() || ``

                    if (heading.includes(query) || title.includes(query)) {
                        article.style.display = ``
                        hasResults = true
                    } else {
                        article.style.display = `none`
                    }
                })

                if (hasResults) {
                    articleResults.style.display = ``
                    noResults.style.display = `none`
                } else {
                    articleResults.style.display = `none`
                    noResults.style.display = ``
                }
            })
        })

        document.addEventListener(`DOMContentLoaded`, () => {
          const filterLinks = document.querySelectorAll(`.filters .filter`)
          const currentUrl = window.location.pathname
          const articles = document.querySelectorAll(`.article-card`)
          const articleResults = document.querySelector(`.article-results`)
          const noResults = document.querySelector(`.no-results`)

        filterLinks.forEach((link) => {
          link.addEventListener(`click`, (e) => {
            e.preventDefault()
            link.classList.add(`is-primary`)
            const siblings = link.parentNode.children
            Array.from(siblings).forEach(sibling => {
                if (sibling !== link) {
                    sibling.classList.remove(`is-primary`)
                }
            })

            const filterTag = link.getAttribute(`data-attribute`)
            let hasResults = false
            
            if (filterTag === `group-all`) {
                articles.forEach(article => {
                    article.style.display = ``
                    hasResults = true
                })
            }else{
                articles.forEach(article => {
                    const tag = article.getAttribute(`data-tag`) || ``
                    if (tag == filterTag) {
                        article.style.display = ``
                        hasResults = true
                    } else {
                        article.style.display = `none`
                    }
                })
            }

            if (hasResults) {
                articleResults.style.display = ``
                noResults.style.display = `none`
            } else {
                articleResults.style.display = `none`
                noResults.style.display = ``
            }
          })

          const filterTag_1 = link.getAttribute(`data-attribute`)
              if(currentUrl.includes(`/tagged/`)){
                if (currentUrl.includes(`/tagged/${filterTag_1}`)) {
                  link.classList.add(`is-primary`)
                } else {
                  link.classList.remove(`is-primary`)
                }
            }
          })
        })

    },
    onUnload() {

    },
})